import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ExpandableText } from "web_myplann/Shared/Components/ExpandableText";

type Props = {
	label: string;
	text: string;
};

export const TaskDescription: FC<Props> = ({ label, text }) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack
			px={spacingTokens.lg}
			py={spacingTokens.md}
			gap={spacingTokens.xs}
			borderTop={1}
			borderColor="surface.border"
		>
			<Typography variant="body2">{label}</Typography>
			<ExpandableText text={text} color={palette.grey[700]} />
		</Stack>
	);
};
